import { useState, useEffect } from 'react'
import { api } from '@/lib/api'

interface PublicConfig {
  telegram_url: string
  crisis_mode: boolean
  max_file_size: number
  allowed_file_types: string[]
  uploads_enabled: boolean
  file_size_limits: Record<string, number>
  crisis_rate_multiplier: number
  crisis_file_size_multiplier: number
  session_timeout_minutes: number
  posthog_enabled: boolean
  posthog_host: string
  app_name: string
  ocr_enabled: boolean
  max_concurrent_uploads: number
  default_page_size: number
}

const defaultConfig: PublicConfig = {
  telegram_url: 'https://t.me/underrubble',
  crisis_mode: true,
  max_file_size: 104857600, // 100MB
  allowed_file_types: ['pdf', 'png', 'jpg', 'jpeg', 'doc', 'docx', 'txt'],
  uploads_enabled: true,
  file_size_limits: {},
  crisis_rate_multiplier: 10,
  crisis_file_size_multiplier: 2.0,
  session_timeout_minutes: 30,
  posthog_enabled: true,
  posthog_host: 'https://us.i.posthog.com',
  app_name: 'Letter Archive',
  ocr_enabled: true,
  max_concurrent_uploads: 3,
  default_page_size: 12,
}

export function useConfig() {
  const [config, setConfig] = useState<PublicConfig>(defaultConfig)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    const fetchConfig = async () => {
      try {
        const response = await api.get('/config/public')
        setConfig({ ...defaultConfig, ...response.data })
      } catch (error) {
        console.error('Failed to fetch config, using defaults:', error)
      } finally {
        setLoading(false)
      }
    }

    fetchConfig()
  }, [])

  return { config, loading }
}
